import React from "react";
import { useSelector } from "react-redux";

import { Icon, IconSize } from "@gaming/xds-react-js";

import { Programs } from "../../models/programsConfig";
import { getCurrentProgram } from "../../redux/selectors";
import { FormattedText } from "../FormattedText";
import * as styles from "./Card.module.css";

export interface CardProps {
  title: string;
  description: string;
  icon?: (_props: React.SVGProps<SVGSVGElement>) => JSX.Element;
}

const useCardLineColorPicker = () => {
  const currentProgram = useSelector(getCurrentProgram);
  switch (currentProgram) {
    case Programs.IdAzure:
      return styles.lineIdAzure;
    case Programs.IdXbox:
    default:
      return styles.lineIdXbox;
  }
};

export const Card = ({ title, description, icon }: CardProps) => {
  const lineStyle = useCardLineColorPicker();
  return (
    <div className={styles.box}>
      <div className={lineStyle} />
      <div className={styles.iconContainer}>
        {icon && <Icon className={styles.icon} icon={icon} iconSize={IconSize.Custom} />}
      </div>
      <div className={styles.content}>
        <p className={styles.title}>{title}</p>
        <FormattedText text={description} className={styles.description} />
        <p />
      </div>
    </div>
  );
};
